import { useGlobalContext } from "../../../../../../Context/Context";
import Button from "../../../../../Custom/Button/Button";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

function ButtonsEdit({ setCurrentState, newData, data, setData, setNewData }) {
  const { dictionary } = useGlobalContext();

  const handleSacuvaj = () => {
    setData(newData);
    setCurrentState("");
  };

  const handleOdustani = () => {
    setNewData(data);
    setCurrentState("");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginTop: "15px"
      }}
    >
      <div onClick={handleOdustani}>
        <Button activation={true} style={styles.button}>
          {dictionary["odustani"]}
        </Button>
      </div>
      <div onClick={handleSacuvaj}>
        <Button activation={true} style={styles.button}>
          {dictionary["sacuvaj"]}
        </Button>
      </div>
    </div>
  );
}

export default ButtonsEdit;
